/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs */

const en_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evals, citation checks and freshness loops in production.`)
};

const ar_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييمات وفحوص استشهاد وحلقات تحديث في الإنتاج.`)
};

const bn_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশনে মূল্যায়ন, উদ্ধৃতি পরীক্ষা আর তাজা রাখার লুপ।`)
};

const de_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evals, Zitationsprüfungen und Frische-Schleifen in Produktion.`)
};

const es_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluaciones, comprobaciones de citas y ciclos de frescura en producción.`)
};

const fr_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluations, contrôles de citations et boucles de fraîcheur en production.`)
};

const pt_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliações, verificações de citações e ciclos de frescura em produção.`)
};

const zh_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产环境做评测、引用检查和新鲜度循环。`)
};

const tr_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretimde değerlendirmeler, alıntı kontrolleri ve tazelik döngüleri.`)
};

const ru_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценки, проверки цитат и циклы свежести в проде.`)
};

const pl_svc_rag_knowledge_assistants_harden_detail6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ewaluacje, kontrole cytowań i pętle świeżości na produkcji.`)
};

/**
* | output |
* | --- |
* | "Evals, citation checks and freshness loops in production." |
*
* @param {Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_harden_detail6 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_harden_detail6(inputs)
	return en_svc_rag_knowledge_assistants_harden_detail6(inputs)
});
export { svc_rag_knowledge_assistants_harden_detail6 as "svc_rag-knowledge-assistants_HARDEN_detail" }